import { PaginatedResponse } from './common.types';

export enum UnitType {
  STUDIO = 'studio',
  ONE_BED = '1bed',
  TWO_BED = '2bed',
  THREE_BED = '3bed',
  PENTHOUSE = 'penthouse',
}

export enum HousekeepingStatus {
  CLEAN = 'clean',
  DIRTY = 'dirty',
  INSPECTED = 'inspected',
  OCCUPIED = 'occupied',
  MAINTENANCE = 'maintenance',
  OUT_OF_ORDER = 'out_of_order',
}

/**
 * Per-property approval workflow. Gates ONLY public (storefront) visibility —
 * never blocks operator data entry. Set by the BestAcco platform (super-admin).
 */
export enum PropertyReviewStatus {
  DRAFT = 'draft',
  PENDING_REVIEW = 'pending_review',
  CHANGES_REQUESTED = 'changes_requested',
  APPROVED = 'approved',
}

export interface Property {
  id: string;
  ownerId: string;
  name: string;
  city: string;
  address: string;
  country: string;
  description: string | null;
  amenities: string[];
  images: string[];
  isActive: boolean;
  reviewStatus: PropertyReviewStatus;
  reviewFeedback: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Unit {
  id: string;
  propertyId: string;
  name: string;
  type: string;
  capacity: number;
  basePrice: string;
  housekeepingStatus: HousekeepingStatus;
  isActive: boolean;
  channelMappings: Record<string, unknown>;
  createdAt: string;
}

export type PaginatedProperties = PaginatedResponse<Property>;
